<template>
  <section>
    <h2 class="mb-0">{{ $t(!isAdmin ? 'connectorSelect.title.default' : 'connectorSelect.title.admin') }}</h2>
    <b-row class="px-2">
      <b-col v-for="option in optionsOrderedByPrice" :key="option.id" cols="4" class="p-2">
        <b-button
          v-if="option.status == 'I'"
          :ref="option.id"
          class="connector-option mb-2 p-4 align-middle"
          :class="{ selected: connector == option.id }"
          :title="option.name"
          :aria-label="`Choose ${option.name}`"
          v-testid="{ id: 'product-connector-item', key: option.name }"
          @click="setConnector(option)"
          @focus="setFocus(option.id)"
          @focusout="unsetFocus"
        >
          <img v-if="option.image" :src="getImage(option.image.original)" alt="" width="100%" />
        </b-button>
        <div v-else title="Out of Stock" class="no-stock mb-2 p-4 align-middle">
          <img v-if="option.image" :src="getImage(option.image.original)" alt="" width="100%" />
          <svg aria-hidden="true"><line x1="0" y1="100%" x2="100%" y2="0" /></svg>
        </div>
        <h3 class="text-primary mb-0 pl-1">{{ option.name }}</h3>
        <h3 class="text-weight-bold text-dark pl-1" v-testid="{ id: 'product-connector-price-message', key: option.name }">${{ option.price.toFixed(2) }}</h3>
      </b-col>
    </b-row>
    <ValidationProvider v-slot="{ errors }" vid="p-connector-select" :rules="{ required: { allowFalse: false } }" slim>
      <input id="product-style-connector" v-model="value" type="text" class="d-none" hidden />
      <span v-if="errors && errors[0]" class="text-danger">{{ $t('connectorSelect.error') }}</span>
    </ValidationProvider>
  </section>
</template>

<script>
import getImage from '@/mixins/getImage';
import { KeyboardNavigationMixins } from '@/mixins/keyboardNavigation';

export default {
  name: 'ConnectorSelect',
  mixins: [getImage, KeyboardNavigationMixins],
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      connector: this.value,
    };
  },
  computed: {
    optionsOrderedByPrice() {
      return [...this.options].sort((a, b) => {
        if (this.isAdmin && b.price === 0) {
          return 1;
        }

        return a.price > b.price ? -1 : 1;
      });
    },
    navigableOptions() {
      return this.optionsOrderedByPrice
        .filter(function (option) {
          return option.status === 'I';
        })
        .map((option) => option.id);
    },
  },
  created() {
    if (!this.value && this.isAdmin) {
      const standardSplitRingConnector = this.options.filter(
        (o) => o.name.toLowerCase().includes('standard') && o.price == 0 && o.status == 'I'
      );
      if (standardSplitRingConnector?.[0]?.id) this.setConnector(standardSplitRingConnector[0]);
    }
  },
  methods: {
    setConnector(connector) {
      if (connector.id == this.connector) {
        return;
      } else {
        this.connector = connector.id;
      }
      this.$emit('input', this.connector);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.connector-option {
  border-radius: 10px;
  border: 2px solid $dp-gray-4;
  height: auto;
  width: 100%;
  background: transparent;
  &.selected {
    border: 2px solid $dp-blue;
    background-color: rgba(204, 236, 249, 0.5);
  }
  &:hover,
  &:active,
  &:focus {
    &:not(.disabled) {
      border: 2px solid $dp-blue;
      box-shadow: 0 0 0 0.2rem $dp-light-blue;
      background-color: rgba(204, 236, 249, 0.5) !important;
    }
  }
}

.no-stock {
  border-radius: 10px;
  border: 2px solid white;
  height: auto;
  width: 100%;
  position: relative;
  img {
    filter: grayscale(80%);
  }
  svg {
    width: 70%;
    height: 70%;
    position: absolute;
    top: 15%;
    left: 15%;
    line {
      stroke: $dp-gray-5;
      stroke-width: 4;
    }
  }
}
</style>
